import { SsrService } from '@/common/services/ssr/ssr.service';
import { environment as env } from '@/env/environment';
import { AfterViewInit, Component } from '@angular/core';

declare const hbspt: any;

@Component({
    selector: 'fe-hbsptform-new',
    templateUrl: './hbsptform-new.component.html',
    styleUrls: ['./hbsptform-new.component.scss'],
})
export class HbsptformNewComponent implements AfterViewInit {
    constructor(private readonly ssr: SsrService) {}

    ngAfterViewInit(): void {
        if (this.ssr.isPlatformServer()) {
            return;
        }
        hbspt.forms.create({
            region: env.hbsptformnew.region,
            portalId: env.hbsptformnew.portalId,
            formId: env.hbsptformnew.formId,
            target: '#hubspotFormNew',
        });
    }
}
